import React, { FC } from 'react';

// components
import BasicButton from '../../components/buttons/basicButton';
import BasicModal from '../../components/modals/basicModal';
import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';
import { FormulaType } from '../../constants/formulaType';
// icons
import ICONS from '../../constants/icons';

// models
import { FormulaTypesData } from '../../models/formula.model';

interface FormulaTypeSelectionModalProps {
    handleGoBack: () => void;
    handleContinueClick: (selectedFormulaType: FormulaType) => void;
}

const FormulaTypeSelectionModal: FC<
    React.PropsWithChildren<FormulaTypeSelectionModalProps>
> = ({ handleGoBack, handleContinueClick }) => {
    return (
        <BasicModal
            childContainerStyle={{ padding: aampeTheme.spacing(3, 0) }}
            width={'600px'}
        >
            <HeaderContent>
                <HeaderIconContainer>
                    <ICONS.messagesEmpty />
                </HeaderIconContainer>
                <HeaderText>Select channel</HeaderText>
            </HeaderContent>
            <ItemsContainer>
                {Object.values(FormulaType).map((formulaType) => {
                    const { Icon, title, standaloneMessages } =
                        FormulaTypesData[formulaType];
                    if (!standaloneMessages) return null;
                    return (
                        <FormulaTypeItem
                            key={formulaType}
                            onClick={() => {
                                handleContinueClick(formulaType);
                            }}
                        >
                            <Icon />
                            <Text>{title}</Text>
                        </FormulaTypeItem>
                    );
                })}
            </ItemsContainer>
            <Buttons>
                <BasicButton
                    isPrimary={false}
                    name={'Go back'}
                    action={handleGoBack}
                    isOutlined
                    isCompact
                />
            </Buttons>
        </BasicModal>
    );
};

const HeaderContent = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
    padding: aampeTheme.spacing(0, 2, 2),
}));

const HeaderIconContainer = styled.div(() => ({
    borderRadius: aampeTheme.borderRadius.default,
    height: 48,
    width: 48,
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

const HeaderText = styled.span(() => ({
    color: aampeTheme.colors.textAccessibleWG01,
    fontSize: '18px',
    fontWeight: 600,
}));

const ItemsContainer = styled.div(() => ({
    border: `solid ${aampeTheme.colors.bordersWG01}`,
    borderWidth: '1px 0',
    padding: aampeTheme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    gap: aampeTheme.spacing(2),
}));

const FormulaTypeItem = styled.div(() => ({
    border: `2px solid ${aampeTheme.colors.bordersWG01}`,
    color: aampeTheme.colors.textAccessibleWG01,
    padding: aampeTheme.spacing(2),
    borderRadius: aampeTheme.borderRadius.default,
    boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
    width: '48%',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(1),
    '&:hover': {
        border: `2px solid ${aampeTheme.colors.solidA01}`,
        color: aampeTheme.colors.solidA01,
    },
}));

const Text = styled.span(() => ({
    fontSize: '24px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
}));

const Buttons = styled.div(() => ({
    marginTop: aampeTheme.spacing(3),
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
    padding: aampeTheme.spacing(0, 2),
}));

export default FormulaTypeSelectionModal;
